import { render } from "./WebsitesComponent.vue?vue&type=template&id=4fca78da&scoped=true"
import script from "./WebsitesComponent.vue?vue&type=script&lang=js"
export * from "./WebsitesComponent.vue?vue&type=script&lang=js"

import "./WebsitesComponent.vue?vue&type=style&index=0&id=4fca78da&scoped=true&lang=css"

import exportComponent from "/Users/luismanuel/Documents/www/adminmkthl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fca78da"]])

export default __exports__